import { LazyView } from "@pdfking/router"
import type { ComponentType } from "preact"

import { CreateHref } from "../router"
import type { DocsPage } from "../types/DocsPage"
import type { DocsTarget } from "../types/DocsTarget"
import { Docs } from "./Docs"

// One view per docs page, made on its first visit, loading the page.json its
// prerender wrote beside it; a hydrating page keeps its html meanwhile.
const Views = new Map<string, ComponentType>()

const View = (href: string): ComponentType =>
  Views.get(href) ??
  Views.set(
    href,
    LazyView(() =>
      fetch(`${href}page.json`)
        .then(response => response.json() as Promise<DocsPage>)
        .then(page => () => <Docs page={page} />)
    )
  ).get(href)!

/** Every docs url: /docs/, a package's index, or one of its pages. */
export const DocsRoute = (target: DocsTarget) => {
  const Page = View(CreateHref("docs", target))
  return <Page />
}
